import React from 'react';

import FirstTitle from "./../../../shared/items/static/firstTitle"
import locales from "./../../../content.json"

import styles from "./whatGetResultBlock.module.scss"

const WhatGetResultBlock = props => {
  return (
    <div className={styles.whatGet}>
      <FirstTitle>{locales[window.userLang].in_the_package}</FirstTitle>

      <div className={styles.whatGetItem}>
        <div className={styles.image} style={{ backgroundImage: `url('./img/slider_1.png')` }}></div>
        <span className={styles.title}>{locales[window.userLang].all_levels}</span>
        <span className={styles.subTitle}>{locales[window.userLang].no_equipment}</span>
      </div>
      <div className={styles.whatGetItem}>
        <div className={styles.image} style={{ backgroundImage: `url('./img/slider_2.png')` }}></div>
        <span className={styles.title}>{locales[window.userLang].running_training}</span>
        <span className={styles.subTitle}>{locales[window.userLang].for_a_race}</span>
      </div>
      <div className={styles.whatGetItem}>
        <div className={styles.image} style={{ backgroundImage: `url('./img/slider_3.png')` }}></div>
        <span className={styles.title}>{locales[window.userLang].guided_meditations}</span>
        <span className={styles.subTitle}>{locales[window.userLang].mind_calm}</span>
      </div>
      <div className={styles.whatGetItem}>
        <div className={styles.image} style={{ backgroundImage: `url('./img/slider_4.png')` }}></div>
      <span className={styles.title}>{locales[window.userLang].interval_walking}</span>
        <span className={styles.subTitle}>{locales[window.userLang].without_a_hitch}</span>
      </div>
    </div>
  )
}

export default WhatGetResultBlock;